import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col w-full space-y-4"
}

import { computed, ref } from "vue";
import { useFriendsStore } from "@/store/useFriendsStore";
import { useAuthStore } from "@/store/useAuthStore";
import TitleMedium from "@/components/Titles/TitleMedium.vue";
import InputText from "@/components/Form/InputText.vue";
import ButtonPrimary from "@/components/Buttons/ButtonPrimary.vue";
import TextSmall from "@/components/Texts/TextSmall.vue";
import FriendRequestManageView from "@/components/Friends/FriendRequestManageView.vue";
import FriendNotificationManageView from "@/components/Friends/FriendNotificationManageView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserNotificationsViewContainer',
  setup(__props) {

const friendsStore = useFriendsStore();
const authStore = useAuthStore();

const nameValue = ref("");

const error = ref(false);
const success = ref(false);

const addFriend = () => {
  error.value = false;
  success.value = false;
  const isSuccess = friendsStore.addFriendRequest(
    authStore.currentUser.id,
    nameValue.value
  );
  if (isSuccess) {
    success.value = true;
  } else {
    error.value = true;
  }
};

const friendRequestsToMe = computed(() => {
  return friendsStore.friendRequestsToMe;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleMedium, { text: "Notifications" }),
    (friendRequestsToMe.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friendRequestsToMe.value, (friend) => {
            return (_openBlock(), _createBlock(FriendNotificationManageView, {
              key: friend.from,
              "friends-request": friend
            }, null, 8, ["friends-request"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})